import { Checkbox as IdskCheckbox } from '@mc-ui/idsk-react-components';

import { withReactHookForm } from '../hoc/withReactHookForm';

export const Checkbox = withReactHookForm(IdskCheckbox);
